import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=7575aaaf&scoped=true"
import script from "./footers.vue?vue&type=script&lang=js"
export * from "./footers.vue?vue&type=script&lang=js"
import style0 from "./footers.vue?vue&type=style&index=0&id=7575aaaf&prod&scoped=true&lang=css"
import style1 from "./footers.vue?vue&type=style&index=1&id=7575aaaf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7575aaaf",
  null
  
)

export default component.exports